module.exports = __webpack_public_path__ + "img/9_5.d0a84371.png";